import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME,
  EncryptYamatoBaggageResultState,
} from './encrypt-yamato-baggage-result.state';

/** Select EncryptYamatoBaggageResult State */
export const selectEncryptYamatoBaggageResultState = createFeatureSelector<EncryptYamatoBaggageResultState>(
  ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME
);

/** Select EncryptYamatoBaggageResult isPending status */
export const selectEncryptYamatoBaggageResultIsPendingStatus = createSelector(
  selectEncryptYamatoBaggageResultState,
  (state) => !!state.isPending
);

/** Select EncryptYamatoBaggageResult isFailure status */
export const selectEncryptYamatoBaggageResultIsFailureStatus = createSelector(
  selectEncryptYamatoBaggageResultState,
  (state) => !!state.isFailure
);
